export type ExperienceEvent = StartEvent | StopEvent;

export type StartEvent = BaseExperienceEvent & {
	action: 'taskStart';
	timeout?: number;
};

export type StopEvent = SuccessEvent | FailEvent | AbortEvent;

export type SuccessEvent = BaseExperienceEvent & {
	action: 'taskSuccess';
	duration: number;
};

export type FailEvent = BaseExperienceEvent & {
	action: 'taskFail';
	duration: number;
	error: Error;
};

export type AbortEvent = BaseExperienceEvent & {
	action: 'taskAbort';
	checkForTimeout: boolean;
	duration: number;
	reason: string;
};

type BaseExperienceEvent = {
	action: string;
	attributes?: object;
	id: string;
	name: string;
	startTime: number;
};

export const isStop = (event: ExperienceEvent): boolean =>
	event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';

export const hasName = (event: ExperienceEvent, ...names: string[]): boolean =>
	names.includes(event.name);
